module.exports = __webpack_public_path__ + "static/media/porg.16afa726.png";